/*
 * @Description: 处理marker数据量过大
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors: YOYO [792611446@qq.com]
 * @Date: 2025-10-24 13:23:25
 * @LastEditTime: 2025-10-30 11:43:01
*/
// import Speech from 'speak-tts'
import Positions from './position.js'
const markerMixin = {
  data() {
    return {
      layer: null,
      flag: 0,
      iconMap: []
    }
  },
  created() {
    this.initMarkerIcon()
  },
  mounted () {
  },
  methods: {
    initMarkerIcon () {
      let iconTemp = ['Other', 0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 19, 21, 23, 25, 29, 31, 33, 35, 37, 39]
      let icon = ['out', 'on', 'Yellow', 'Red']

      const iconMap = []
      for (let [index, value] of Object.entries(icon)) {
        for (let [iC, vC] of Object.entries(iconTemp)) {
          iconMap.push({
            url: require(`./../assets/img/back/baiduIcon1/${value}${vC}.png`),
            type:`${value}${vC}`,
            anchor: new AMap.Pixel(10, 14),
            size: new AMap.Size(19, 27),
            zIndex: value == 'Red' ? 9999 : 99,
          })
        }
      }

      this.iconMap = iconMap
      // console.log(888888888, iconMap)
    },
    /**
     * 将数组按指定大小分割成多个子数组
     * @param {Array} arr - 原数组
     * @param {number} size - 每个子数组的最大长度
     * @returns {Array} 分割后的子数组集合
     */
    chunkArray(arr, size) {
      const chunks = [];
      for (let i = 0; i < arr.length; i += size) {
        // 从索引i开始，截取size长度的子数组
        chunks.push(arr.slice(i, i + size));
      }
      return chunks;
    },
    /**
     * 用async/await分批处理
     */
    async processInBatchesAsync() {
      // 创建 AMap.LabelsLayer 图层
      // var layer = new AMap.LabelsLayer({
      //   zooms: [3, 20],
      //   zIndex: 1000,
      //   collision: false
      // });
      // this.layer = layer

      // 将图层添加到地图
      // this.myMap.add(layer)
      for (let i = 0; i < this.chunks.length; i++) {
        await this.processChunkAsync(this.chunks[i], i);
      }
      console.log('所有数据处理完成');
    },
    /**
     * 异步处理单批数据（返回Promise）
     */
    processChunkAsync(chunk, index) {
      let self = this
      return new Promise(resolve => {
        setTimeout(() => {
          // console.log(chunk)
          console.log(`处理第 ${index + 1} 批，共 ${chunk.length} 条数据`);
          let self = this
          let markerList = []
          chunk.forEach(item => {
            let { id, name, installGps, deviceType, isOnline, isFault, isAlarm } = item

            if (!installGps) return
            let lonlat = installGps.split(',')
            if (!lonlat || !lonlat.length) return

            let iconTemp = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 19, 21, 23, 25, 29, 31, 33, 35, 37, 39].indexOf(deviceType) == -1 ? 'Other' : deviceType

            let icon = !isOnline ? `out${iconTemp}` : isFault ? `Yellow${iconTemp}` : isAlarm ? `Red${iconTemp}` : `on${iconTemp}`

            if (isNaN(lonlat[0])) {
              lonlat[0] = 0
            }
            if (isNaN(lonlat[1])) {
              lonlat[1] = 0
            }

            // var marker = new AMap.Marker({
            //   position: new AMap.LngLat(lonlat[0] || 0, lonlat[1] || 0),
            //   icon: require(`./../assets/img/back/baiduIcon1/${icon}.png`),
            //   title: name,
            // })
            // marker.id = id
            let iconIndex = this.iconMap.findIndex(({ type }) => type == icon)

             markerList.push({
              lnglat: [lonlat[0] || 0, lonlat[1] || 0],
              style: iconIndex == -1 ? 0 : iconIndex,
              flag: this.flag
            })
            this.flag ++
          })

          // var styleObjectArr = [{
          //   url: require(`./../assets/img/back/baiduIcon1/Red0.png`),
          //   anchor: new AMap.Pixel(9, 15),
          //   size: new AMap.Size(19, 31),
          //   zIndex: 3,
          // }]

          var massMarks = new AMap.MassMarks(markerList, {
            style: this.iconMap,
            zooms: [3, 14]
          })

          massMarks.on('click', function(event) {
            let { flag, lnglat } = event.data
            let item = self.markerList[flag]
            // console.log(event.data)

            let temp = self.$refs.info_window
            temp.style.display = 'block'

            self.infoData = item
            self.infoWindowBg = item.isFault ? 'yellow' : item.isAlarm ? 'red' : 'blue'

            self.infoItem = self.getInfoWindowData(temp)

            let { lng, lat } = lnglat
            self.myMap.panTo([lng, lat])

            setTimeout(() => {
              self.infoItem.open(self.myMap, self.myMap.getCenter())
            }, 400)    
          })


          // 4. 将海量点添加到地图上
          massMarks.setMap(this.myMap);
          // console.log(markerList)
          // this.myMap.add(markerList)
          // 模拟异步处理
          resolve();
        }, 50);
      });
    },
    /**
     * @Description JLHW海量点数据2
     * @Author      YOYO - 2025-10-27
     */
    processChunkAsync2 (chunk, index) {
      let self = this
      return new Promise(resolve => {
        setTimeout(() => {
          this.markerList = chunk
          console.log(`处理第 ${index + 1} 批，共 ${chunk.length} 条数据`);
          let markerList = []
          this.markerList.forEach(item => {
            let { id, name, installGps, deviceType, isOnline, isFault, isAlarm } = item

            if (!installGps) return
            let lonlat = installGps.split(',')
            if (!lonlat || !lonlat.length) return

            let iconTemp = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 19, 21, 23, 25, 29, 31, 33, 35, 37, 39].indexOf(deviceType) == -1 ? 'Other' : deviceType

            let icon = !isOnline ? `out${iconTemp}` : isFault ? `Yellow${iconTemp}` : isAlarm ? `Red${iconTemp}` : `on${iconTemp}`

            if (isNaN(lonlat[0])) {
              lonlat[0] = 0
            }
            if (isNaN(lonlat[1])) {
              lonlat[1] = 0
            }

            const icons = {
              type: "image", //图标类型，现阶段只支持 image 类型
              image: "https://a.amap.com/jsapi_demos/static/demo-center/marker/express2.png", //可访问的图片 URL
              size: [64, 30], //图片尺寸
              anchor: "center", //图片相对 position 的锚点，默认为 bottom-center
            };

            var marker = new AMap.LabelMarker({
              position: new AMap.LngLat(lonlat[0] || 0, lonlat[1] || 0),
              // icon: require(`./../assets/img/back/baiduIcon1/${icon}.png`),
              name,
              icon: icons
            })
            marker.id = id

            AMap.event.addListener(marker, 'click', function () {
              let temp = self.$refs.info_window
              temp.style.display = 'block'
              self.infoData = item
              self.infoWindowBg = item.isFault ? 'yellow' : item.isAlarm ? 'red' : 'blue'

              self.infoItem = self.getInfoWindowData(temp)

              let { lng, lat } = marker.getPosition()
              self.myMap.panTo([lng, lat])

              setTimeout(() => {
                self.infoItem.open(self.myMap, self.myMap.getCenter())
              }, 400)

            })

            markerList.push(marker)
          })
          this.layer.add(markerList)
          resolve();
        }, 2000);
      });
      // 聚合样式-修改

      // let markerClusterer = new AMap.MarkerClusterer(this.myMap, markerList, { /*styles,*/ minClusterSize: 60, maxZoom: 17 })

      // this.myMap.setFitView()
      
    },
    /**
     * @Description JLHW海量点数据3
     * @Author      YOYO - 2025-10-27
     */
    processChunkAsync3 (chunk, index) {
      let self = this
      return new Promise(resolve => {
        setTimeout(() => {
          this.markerList = chunk
          console.log(`处理第 ${index + 1} 批，共 ${chunk.length} 条数据`);
          let markerList = []

          this.markerList.forEach(item => {
            let { id, name, installGps, deviceType, isOnline, isFault, isAlarm } = item

            if (!installGps) return
            let lonlat = installGps.split(',')
            if (!lonlat || !lonlat.length) return

            let iconTemp = [0, 1, 2, 3, 6, 7, 8, 9, 10, 11, 12, 13, 16, 17, 19, 21, 23, 25, 29, 31, 33, 35, 37, 39].indexOf(deviceType) == -1 ? 'Other' : deviceType

            let icon = !isOnline ? `out${iconTemp}` : isFault ? `Yellow${iconTemp}` : isAlarm ? `Red${iconTemp}` : `on${iconTemp}`

            if (isNaN(lonlat[0])) {
              lonlat[0] = 0
            }
            if (isNaN(lonlat[1])) {
              lonlat[1] = 0
            }

            var marker = new AMap.LabelMarker({
              position: [lonlat[0] || 0, lonlat[1] || 0],
              icon: {
                type: 'image',
                // image: require(`./../assets/img/back/baiduIcon1/${icon}.png`),
                image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
                anchor: 'bottom-center',
              },
              name,
            });
            marker.id = id


            // AMap.event.addListener(marker, 'click', function () {
            //   let temp = self.$refs.info_window
            //   temp.style.display = 'block'
            //   self.infoData = item
            //   self.infoWindowBg = item.isFault ? 'yellow' : item.isAlarm ? 'red' : 'blue'

            //   self.infoItem = self.getInfoWindowData(temp)

            //   let { lng, lat } = marker.getPosition()
            //   self.myMap.panTo([lng, lat])

            //   setTimeout(() => {
            //     self.infoItem.open(self.myMap, self.myMap.getCenter())
            //   }, 400)

            // })

            markerList.push(marker)
          })

          // 一次性将海量点添加到图层
          this.layer.add(markerList);
          
          resolve();
        }, 50);
      });



        // 普通点
        // var normalMarker = new AMap.Marker({
        //     anchor: 'bottom-center',
        //     offset: [0, -15],
        // });
    }
  }
}
export default markerMixin;
